// import React from "react"
// import { cn } from "../../lib/utils"

// const RadioGroup = React.forwardRef(({ className, onValueChange, value, ...props }, ref) => {
//   const handleChange = (e) => {
//     if (onValueChange) {
//       onValueChange(e.target.value)
//     }
//   }

//   return <div ref={ref} className={cn("grid gap-2", className)} {...props} />
// })
// RadioGroup.displayName = "RadioGroup"

// const RadioGroupItem = React.forwardRef(({ className, id, value, ...props }, ref) => {
//   return (
//     <input
//       ref={ref}
//       id={id}
//       type="radio"
//       value={value}
//       className={cn(
//         "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
//         className,
//       )}
//       {...props}
//     />
//   )
// })
// RadioGroupItem.displayName = "RadioGroupItem"

// export { RadioGroup, RadioGroupItem }


"use client"

import React from "react"
import { cn } from "../../lib/utils"

// Create a context for the RadioGroup
const RadioGroupContext = React.createContext(null)

const RadioGroup = React.forwardRef(({ className, onValueChange, value, ...props }, ref) => {
  // Create a context value with the current value and change handler
  const contextValue = React.useMemo(
    () => ({
      value,
      onValueChange,
    }),
    [value, onValueChange],
  )

  return (
    <RadioGroupContext.Provider value={contextValue}>
      <div ref={ref} className={cn("grid gap-2", className)} {...props} />
    </RadioGroupContext.Provider>
  )
})
RadioGroup.displayName = "RadioGroup"

const RadioGroupItem = React.forwardRef(({ className, id, value, ...props }, ref) => {
  // Get the parent RadioGroup's context
  const context = React.useContext(RadioGroupContext)

  if (!context) {
    throw new Error("RadioGroupItem must be used within a RadioGroup")
  }

  const isChecked = context.value === value

  const handleChange = (e) => {
    if (context.onValueChange) {
      context.onValueChange(e.target.value)
    }
  }

  return (
    <input
      ref={ref}
      id={id}
      type="radio"
      value={value}
      checked={isChecked}
      onChange={handleChange}
      className={cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  )
})
RadioGroupItem.displayName = "RadioGroupItem"

export { RadioGroup, RadioGroupItem }
